import { cva } from "class-variance-authority";

/** Shared link styling; the 12px size is reserved for the private footer link. */
export const inlineLinkVariants = cva(
  [
    "font-(family-name:--font-family-title)",
    "font-(number:--font-weight-medium)",
    "cursor-pointer",
    "select-none",
    "transition-colors",
    "duration-200",
    "ease-in-out",
    "outline-none",
    "rounded-(--radius-sm)",
    "focus-visible:ring-2",
    "focus-visible:ring-(--color-inline-link-focus-ring)",
    "focus-visible:ring-offset-(--spacing-4)",
    "active:bg-(--color-inline-link-pressed-bg)",
  ],
  {
    variants: {
      size: {
        xs: [
          "text-(length:--font-size-title-xs)",
          "leading-(--font-line-height-16)",
        ],
        sm: [
          "text-(length:--font-size-title-sm)",
          "leading-(--font-line-height-20)",
        ],
        md: [
          "text-(length:--font-size-title-md)",
          "leading-(--font-line-height-24)",
        ],
      },
      variant: {
        contextual: [
          "text-(--color-inline-link-contextual)",
          "no-underline",
          "hover:underline",
          "underline-offset-4",
        ],
        navigational: [
          "text-(--color-inline-link-navigational)",
          "text-start",
          "underline",
          "underline-offset-4",
          "hover:text-(--color-inline-link-navigational-hover)",
        ],
      },
      destructive: {
        true: [
          "text-(--color-text-destructive)",
          "hover:text-(--color-text-destructive)",
        ],
      },
      disabled: {
        true: ["opacity-50", "pointer-events-none"],
      },
    },
    defaultVariants: {
      size: "md",
      variant: "contextual",
    },
  },
);
